/**
 * Contact Hero Section - Copy to clipboard functionality
 */
(function() {
  'use strict';

  const section = document.querySelector('#hero-contact');
  if (!section) return;

  const copyButtons = section.querySelectorAll('.contact-hero__copy-btn');

  copyButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const textToCopy = this.getAttribute('data-copy');
      if (!textToCopy) return;

      navigator.clipboard.writeText(textToCopy).then(function() {
        // Show copied state
        btn.classList.add('contact-hero__copy-btn--copied');

        // Temporarily change icon to checkmark
        const originalSVG = btn.innerHTML;
        btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"></path></svg>';

        setTimeout(function() {
          btn.innerHTML = originalSVG;
          btn.classList.remove('contact-hero__copy-btn--copied');
        }, 2000);
      }).catch(function() {
        // Fallback for older browsers
        var textArea = document.createElement('textarea');
        textArea.value = textToCopy;
        textArea.style.position = 'fixed';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          btn.classList.add('contact-hero__copy-btn--copied');
          var originalSVG = btn.innerHTML;
          btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"></path></svg>';
          setTimeout(function() {
            btn.innerHTML = originalSVG;
            btn.classList.remove('contact-hero__copy-btn--copied');
          }, 2000);
        } catch (err) {
          console.error('Copy failed', err);
        }
        document.body.removeChild(textArea);
      });
    });
  });
})();
